import ReactHtmlParser from "react-html-parser";
import { transform } from "core/components/cmsBlock/Parser";
import { nameImageLinks } from "utils/nameCmsLinks";

export const CmsDataFragment = ({ content }) =>
  ReactHtmlParser(content, {
    preprocessNodes: nameImageLinks,
    transform: transform,
  });
